"use client";

import { Button } from "@/components/shadcn/button";
import { Card } from "@/components/shadcn/card";
import { VimeoPlayer } from "@/components/Vimeo-Player";
import type { Videos } from "@prisma/client";
import { LockIcon } from "lucide-react";
import { useTranslations } from "next-intl";

type VideoDetailPlayerProps = {
    currentVideo: Videos | null;
    seekTime?: number;
    autoPlay: boolean;
    onLoginRequest: () => void;
    onEnd: () => void;
};

export function VideoDetailPlayer({
    currentVideo,
    seekTime,
    autoPlay,
    onLoginRequest,
    onEnd,
}: VideoDetailPlayerProps) {
    const t = useTranslations("series");

    return (
        <Card className="overflow-hidden p-0">
            <div className="aspect-video w-full">
                {currentVideo ? (
                    <VimeoPlayer
                        video={currentVideo}
                        seekTime={seekTime}
                        autoPlay={autoPlay}
                        onEnded={onEnd}
                    />
                ) : (
                    <div className="flex h-full w-full flex-col items-center justify-center gap-4 p-6 text-center">
                        <LockIcon aria-hidden="true" />
                        <p>{t("loginToWatch")}</p>
                        <Button type="button" onClick={onLoginRequest}>
                            {t("login")}
                        </Button>
                    </div>
                )}
            </div>
        </Card>
    );
}
